<template>
  <div class="templateOne">
    <title-widge
      :title="data.title"
      :subTitle="data.subTitle"
      :fontBg="fontBg"
    ></title-widge>
    <div class="divImg">
      <img v-lazy="data.url" />
      <div class="divDesc">{{ data.desc }}</div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    fontBg: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.templateOne {
  background: rgba(255, 255, 255, 1);
  padding-bottom: 86px;
  padding-top: 86px;
  .divImg {
    width: 1053px;
    margin: 0 auto;
    text-align: center;
    img {
      width: 1053px;
    }
    .divDesc {
      height: 19px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      margin-top: 36px;
    }
  }
}
</style>
